<template>
  <v-card>
    <v-card-text>
      <v-form>
        <v-text-field
          label="CUIT"
          id="CUIT"
          v-model="identification"
          type="number"
          append-outer-icon="mdi-magnify"
          @click:append-outer="doSearch"
        />
        <v-card v-if="person" class="d-flex flex-column">
          <v-card-text>
            <div class="text-subtitle-1 text-center">{{ person.name }}</div>
            <div class="text-subtitle-1 text-center">
              {{
                person.identification_type_code + " - " + person.identification
              }}
            </div>
            <div class="text-subtitle-1 text-center">{{ person.address }}</div>
          </v-card-text>
          <v-card-actions class="d-flex flex-justify-end">
            <v-btn
              color="success"
              class="ma-2"
              block
              :outlined="$vuetify.breakpoint.mdAndUp"
              @click="onSave"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: "PersonTaxRecord",

  components: {
    //
  },

  data: () => ({
    identification: "",
    person: null
  }),

  methods: {
    onCUITChange() {
      if (this.identification.replace(/\D/g, "").length === 11) {
        this.doSearch();
      } else {
        this.person = null;
      }
    },

    async doSearch() {
      try {
        this.$bRoot.errors = null;
        let CUIT = this.identification.replace(/\D/g, "");
        if (CUIT.length !== 11) {
          throw "El número de CUIT debe contener 11 dígitos";
        }
        let response = await this.$bRoot.getObjectByURL(
          "/data/taxrecord/" + CUIT + "/"
        );
        this.person = response;
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      }
    },

    onSave() {
      let obj = {
        name: this.$bRoot.isNullOrEmpty(this.person, "name", "Sin Datos"),
        identification_type: this.$bRoot.isNullOrEmpty(
          this.person.identification_type,
          "url",
          null
        ),
        identification_type_code: this.$bRoot.isNullOrEmpty(
          this.person.identification_type,
          "code",
          null
        ),
        identification: this.$bRoot.isNullOrEmpty(
          this.person,
          "identification",
          null
        ),
        fiscal_address: this.$bRoot.isNullOrEmpty(this.person, "address", null),
        fiscal_locality: this.$bRoot.isNullOrEmpty(
          this.person,
          "locality_description",
          null
        ),
        fiscal_province: this.$bRoot.isNullOrEmpty(
          this.person,
          "province_description",
          null
        ),
        fiscal_zip_code: this.$bRoot.isNullOrEmpty(
          this.person,
          "zip_code",
          null
        )
      };
      this.$emit("save", obj);
    }
  },

  watch: {
    identification: {
      handler() {
        this.onCUITChange();
      }
    },
    deep: true
  }
};
</script>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
